import { ComponentHarness } from '@angular/cdk/testing'
import { Component } from '@angular/core'
import { RouterOutlet } from '@angular/router'
import { MessengerComponent } from './modules/core/components/messenger.component'
import { VersionPopoverComponent } from './modules/core/components/version-popover.component'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  imports: [RouterOutlet, MessengerComponent, VersionPopoverComponent],
})
export class AppComponent {}

export class AppComponentHarness extends ComponentHarness {
  // noinspection JSUnusedGlobalSymbols
  static hostSelector = 'app-root'

  protected getMessenger = this.locatorForOptional('app-messenger')
  protected getVersionPopover = this.locatorForOptional('app-version-popover')

  async hasMessenger() {
    return !!(await this.getMessenger())
  }

  async hasVersionPopover() {
    return !!(await this.getVersionPopover())
  }
}
